import { Component, OnInit } from '@angular/core';
import { BusinessAccountsService } from './business-accounts.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';
import { CommonInternationalBusinessComponent } from 'src/app/shared/components/international-business/international-business.component';
import { CommonDiscoverWhyComponent } from 'src/app/shared/components/discover-why/discover-why.component';
import { CommonLatestNewsComponent } from 'src/app/shared/components/latest-news/latest-news.component';
import { CommonFaqComponent } from 'src/app/shared/components/faq/faq-on.component';
import { CommonReadyToComponent } from 'src/app/shared/components/ready-to/ready-to.component';
import { CommonExploreGlobalPanelComponent } from 'src/app/shared/components/explore-global-panel/explore-more.component';
import { NewBusinessHeroHeaderComponent } from './new-business-hero-header/new-business-hero-header.component';
import { EfficientPaymentComponent } from './efficient-payment/efficient-payment.component';
import { MultiCurrencyComponent } from './multi-currency/multi-currency.component';
import { GlobalReachComponent } from './global-reach/global-reach.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-business-accounts',
  templateUrl: './business-accounts.component.html',
  imports: [
    NewBusinessHeroHeaderComponent,
    GlobalReachComponent,
    MultiCurrencyComponent,
    EfficientPaymentComponent,
    CommonCompaniesPanelComponent,
    CommonInternationalBusinessComponent,
    CommonDiscoverWhyComponent,
    CommonFaqComponent,
    CommonLatestNewsComponent,
    CommonReadyToComponent,
    CommonExploreGlobalPanelComponent,
  ],
})
export class BusinessAccountsComponent implements OnInit {
  newsList:any;
  faqData:any;
  exploreMore:any;
  discoverData:any;
  ibData:any;
  companiesData:any;
  readyToData:any;
  queryParams: any;
  constructor(
    private businessAccountService: BusinessAccountsService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };

  ngOnInit(): void {
    this.businessAccountService.getBusinessAccPageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo'][0].fields;
    if (data?.seoMetadataReference?.fields.title) {
      this.metaBody.title = data?.seoMetadataReference?.fields.title;
    } else {
      this.metaBody.title =
        'Verto: Cross-border payments platform for businesses';
    }
    if (data?.seoMetadataReference?.fields.description) {
      this.metaBody.description =
        data?.seoMetadataReference?.fields.description;
    } else {
      this.metaBody.description =
        'Verto: Cross-border payments platform for businesses across the globe.';
    }
    this.metaBody.type = 'Business Account';
    this.metaBody.url = this.getUrl;
    this.metaBody.image =
      data?.psHeroPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);
    this.newsList = data.psBlogPanel[0].fields;
    this.faqData = data.psFaqPanel.fields;
    this.exploreMore = data.psOtherProductsPanel.fields;
    this.discoverData = data.psCustomerStories.fields;
    this.ibData = data.psValuePropPanel2.fields;
    let logos = data.psCustomerStatsContentPanel.fields?.components.map(
      (el:any) => el?.fields?.image?.fields?.file?.url
    );
    this.companiesData = logos;
    this.readyToData = data.psGetStartedPanel.fields;

    this.posthogService.capturePageViewEvent('business_accounts');
  }
}
